import { ticketStatuses } from "@megaron/megarax-uri";

import type { TicketStatus } from "./tickets";

export const supportTicketAdminRoleNames = ["support.admin", "crm.admin"] as const;

export const supportTicketStatusManagerRoleNames = [
  "support.status-manager",
  ...supportTicketAdminRoleNames,
] as const;

export function isTicketOpenForEdit(status: TicketStatus | string): boolean {
  return status !== "resolved" && status !== "closed";
}

export function hasSupportTicketStatusManagerRole(roles: readonly string[] | undefined): boolean {
  return supportTicketStatusManagerRoleNames.some((role) => roles?.includes(role) ?? false);
}

function isSupportTicketActivityPromotion(
  oldStatus: TicketStatus | string,
  newStatus: TicketStatus | string,
): boolean {
  return oldStatus === "new" && newStatus === "open";
}

export function canChangeSupportTicketStatus(
  oldStatus: TicketStatus | string,
  newStatus: TicketStatus | string,
  hasStatusManagerRole: boolean,
): boolean {
  if (oldStatus === newStatus) return true;
  if (isSupportTicketActivityPromotion(oldStatus, newStatus)) return true;
  return hasStatusManagerRole;
}

export function selectableSupportTicketStatuses(
  currentStatus: TicketStatus | string,
  hasStatusManagerRole: boolean,
): TicketStatus[] {
  return ticketStatuses.filter((status) => canChangeSupportTicketStatus(currentStatus, status, hasStatusManagerRole));
}
